<template>
  <li class="dropdownItem dropdownItem__mobilePay">
    <a
      class="dropdownItem__toggle user-profile dropdown-toggle"
      href="javascript:;"
      data-toggle="dropdown"
      aria-expanded="true"
    >
      司機資料
      <span class="dropdownItem__icon fa fa-angle-down"></span>
    </a>
    <ul class="dropdown-menu dropdown-usermenu pull-right">
      <!-- <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/DriverMonitor'"
          v-if="permissionDriverMonitor"
        >
          圖台監控
        </router-link>
      </li> -->
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/DriverMonitorV2'"
          v-if="permissionDriverMonitor"
        >
          圖台監控
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link class="dropdownItem__href" :to="'/serviceMain/driverList'">
          司機資料
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/DriverTrajectory'"
          v-if="permissionDriverTrajectory"
        >
          行車軌跡
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/DriverBehavior/'"
        >
          行為查看
        </router-link>
      </li>
      <li class="dropdownItem__listItem">
        <router-link
          class="dropdownItem__href"
          :to="'/serviceMain/SearchDriverMeter'"
        >
          查詢跳錶紀錄
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  props: ['permissionDriverMonitor', 'permissionDriverTrajectory'],
}
</script>

<style lang="scss" scoped>
@import 'src/scss/_dropdownItem.scss';
</style>



// WEBPACK FOOTER //
// src/components/dropDown/DropdownDriverInfo.vue